import { LitElement, html, css } from 'lit';

export class CrusherCardLink extends LitElement {
  static properties = {
    href: { type: String, reflect: true },
    target: { type: String },
    rel: { type: String },
    label: { type: String },
    disabled: { type: Boolean, reflect: true },
  };

  constructor() {
    super();
    this.href = '';
    this.target = '';
    this.rel = '';
    this.label = '';
    this.disabled = false;
  }

  static styles = css`
    :host {
      display: block;
      color: inherit;
      text-decoration: none;
    }

    :host([disabled]) {
      opacity: var(--crusher-opacity-disabled);
      pointer-events: none;
    }

    a {
      display: block;
      inline-size: 100%;
      block-size: 100%;
      color: inherit;
      text-decoration: none;
      cursor: inherit;
    }
  `;

  _onClick(event) {
    if (this.disabled) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  render() {
    const rel = this.rel || (this.target === '_blank' ? 'noopener noreferrer' : '');

    return html`
      <a
        href=${this.disabled ? '' : this.href}
        target=${this.target || ''}
        rel=${rel}
        aria-label=${this.label || ''}
        aria-disabled=${this.disabled ? 'true' : 'false'}
        tabindex=${this.disabled ? '-1' : '0'}
        @click=${this._onClick}
      >
        <slot></slot>
      </a>
    `;
  }
}

customElements.define('crusher-card-link', CrusherCardLink);
